export default "__VITE_ASSET__DQQ$Y$4___"